(function () {
  'use strict';

  function buildTOC() {
    var list = document.getElementById('fof-toc-list');
    var box  = document.getElementById('fof-toc-box');
    if (!list || !box) return;
    var content = document.querySelector('.fof-article-body');
    if (!content) return;
    var headings = content.querySelectorAll('h2');
    if (headings.length < 1) { box.style.display = 'none'; return; }
    list.innerHTML = '';
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'abschnitt-' + (i + 1);
      var li = document.createElement('li');
      var a  = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var el = document.getElementById(h.id);
        if (!el) return;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      });
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  function initTOCToggle() {
    var btn   = document.querySelector('.fof-toc__toggle');
    var list  = document.getElementById('fof-toc-list');
    var arrow = document.querySelector('.fof-toc__arrow');
    if (!btn || !list) return;
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        list.setAttribute('hidden', '');
        if (arrow) arrow.classList.remove('is-open');
      } else {
        list.removeAttribute('hidden');
        if (arrow) arrow.classList.add('is-open');
      }
    });
  }

  function initFAQ() {
    document.querySelectorAll('.fof-faq__item').forEach(function (item) {
      var btn    = item.querySelector('.fof-faq__question');
      var answer = item.querySelector('.fof-faq__answer');
      var icon   = item.querySelector('.fof-faq__icon');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.fof-faq__question').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.fof-faq__answer').forEach(function (a) {
          a.setAttribute('hidden', '');
          a.style.display = 'none';
        });
        document.querySelectorAll('.fof-faq__icon').forEach(function (ic) {
          ic.textContent = '+';
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
          answer.style.display = 'block';
          if (icon) icon.textContent = '−';
        }
      });
    });
  }

  function initVideoFacade() {
    document.querySelectorAll('.fof-video-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var id = facade.getAttribute('data-youtube-id');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        facade.innerHTML = '';
        facade.appendChild(iframe);
      });
    });
  }

  function init() {
    buildTOC();
    initTOCToggle();
    initFAQ();
    initVideoFacade();
  }

  function waitAndInit() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var content = document.querySelector('.fof-article-body');
      if (content && content.querySelectorAll('h2').length > 0) {
        clearInterval(interval);
        init();
      } else if (attempts >= 30) {
        clearInterval(interval);
        init();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

})();